import React, { } from 'react';
import logoPng from './../../assets/images/logo-full.png'
import './../../assets/styles/Logo.css'


const Logo = ({ appState }) => {
    return (
        <img className={appState === "landingpage" || appState === "login" ? "main_logo" : "logo_none"} src={logoPng} />
    );
}

export default Logo;